// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__5tTC2","container":"tag_container__k0pmj","dot":"tag_dot__Zxlci"};